import {
  AdjustmentsHorizontalIcon,
  AdjustmentsVerticalIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowDownRightIcon,
  NoSymbolIcon,
  BellIcon,
  CakeIcon,
  CalendarIcon,
  ChatBubbleLeftRightIcon,
  CheckIcon,
  CheckCircleIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ClockIcon,
  ArrowDownTrayIcon,
  ExclamationTriangleIcon,
  ExclamationCircleIcon,
  EyeIcon,
  EyeSlashIcon,
  HandRaisedIcon,
  HomeIcon,
  InformationCircleIcon,
  MapPinIcon,
  ArrowLeftEndOnRectangleIcon,
  ArrowLeftStartOnRectangleIcon,
  EnvelopeIcon,
  Bars3Icon,
  PaperAirplaneIcon,
  PaintBrushIcon,
  PlusIcon,
  PencilIcon,
  PhoneIcon,
  ArrowUturnLeftIcon,
  MagnifyingGlassIcon,
  SparklesIcon,
  TicketIcon,
  TrashIcon,
  Bars4Icon,
  UserGroupIcon,
  UsersIcon,
  UserIcon,
  QrCodeIcon,
  QuestionMarkCircleIcon,
  XCircleIcon,
  XMarkIcon,
  MinusIcon,
  LightBulbIcon,
  ArrowTopRightOnSquareIcon,
  LinkIcon,
  ListBulletIcon,
  NumberedListIcon,
  FaceSmileIcon,
  CalendarDateRangeIcon,
  LockOpenIcon
} from "@heroicons/react/24/outline";

import {
  PlayIcon,
  LockClosedIcon,
  Cog6ToothIcon,
  ComputerDesktopIcon,
  EllipsisHorizontalIcon
} from "@heroicons/react/24/solid";

export const Icons = {
  Adjustments: AdjustmentsHorizontalIcon,
  ArrowLeft: ArrowLeftIcon,
  ArrowRight: ArrowRightIcon,
  ArrowDownRightIcon: ArrowDownRightIcon,
  ArrowTopRightOnSquareIcon: ArrowTopRightOnSquareIcon,
  Ban: NoSymbolIcon,
  Bell: BellIcon,
  Cake: CakeIcon,
  Calendar: CalendarIcon,
  CalendarDateRangeIcon: CalendarDateRangeIcon,
  ChatBubble: ChatBubbleLeftRightIcon,
  Check: CheckIcon,
  CheckCircle: CheckCircleIcon,
  ChevronDown: ChevronDownIcon,
  ChevronLeft: ChevronLeftIcon,
  ChevronRight: ChevronRightIcon,
  Clock: ClockIcon,
  Cog: Cog6ToothIcon,
  DesktopComputer: ComputerDesktopIcon,
  DotsHorizontal: EllipsisHorizontalIcon,
  Download: ArrowDownTrayIcon,
  Exclamation: ExclamationTriangleIcon,
  FaceSmile: FaceSmileIcon,
  ExclamationCircle: ExclamationCircleIcon,
  Eye: EyeIcon,
  EyeOff: EyeSlashIcon,
  Hand: HandRaisedIcon,
  Home: HomeIcon,
  InformationCircle: InformationCircleIcon,
  LinkIcon: LinkIcon,
  ListBullet: ListBulletIcon,
  LightBulb: LightBulbIcon,
  LocationMarker: MapPinIcon,
  LockClosed: LockClosedIcon,
  LockOpen: LockOpenIcon,
  Login: ArrowLeftEndOnRectangleIcon,
  Logout: ArrowLeftStartOnRectangleIcon,
  Mail: EnvelopeIcon,
  Menu: Bars3Icon,
  Minus: MinusIcon,
  NumberedList: NumberedListIcon,
  PaintBrush: PaintBrushIcon,
  PaperAirplane: PaperAirplaneIcon,
  Phone: PhoneIcon,
  Play: PlayIcon,
  Plus: PlusIcon,
  Pencil: PencilIcon,
  Reply: ArrowUturnLeftIcon,
  Search: MagnifyingGlassIcon,
  Sparkles: SparklesIcon,
  Ticket: TicketIcon,
  Trash: TrashIcon,
  UserGroup: UserGroupIcon,
  Users: UsersIcon,
  User: UserIcon,
  ViewList: Bars4Icon,
  Qrcode: QrCodeIcon,
  QuestionMarkCircle: QuestionMarkCircleIcon,
  XCircle: XCircleIcon,
  X: XMarkIcon,
};